import { AfterViewInit, Component, EventEmitter, forwardRef, Input, NgZone, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { TextareaComponent } from '../textarea/textarea.component';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => WysiwygComponent),
    multi: true
};

@Component({
    selector: 'chassis-wysiwyg',
    templateUrl: './wysiwyg.component.html',
    styleUrls: ['./wysiwyg.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class WysiwygComponent extends TextareaComponent implements OnInit, AfterViewInit {

    @Input() settings = {};

    @Input() toolbar: Array<any>;
    @Input() placeholder: string;
    @Input() shortcuts: boolean;
    @Input() fonts: Array<string>;

    @Output() init    = new EventEmitter();
    @Output() enter   = new EventEmitter();
    @Output() focus   = new EventEmitter();
    @Output() blur    = new EventEmitter();
    @Output() keyup   = new EventEmitter();
    @Output() keydown = new EventEmitter();
    @Output() paste   = new EventEmitter();
    @Output() upload  = new EventEmitter();
    @Output() change  = new EventEmitter();

    protected summernote;

    constructor(protected zone: NgZone) {
        super();
    }

    ngOnInit() {

        this.setSetting('toolbar', this.toolbar);
        this.setSetting('placeholder', this.placeholder);
        this.setSetting('shortcuts', this.shortcuts);
        this.setSetting('fonts', this.fonts);

    }

    ngAfterViewInit() {

        const self = this;

        const summernote = (<any>$('.summernote'));

        this.summernote = summernote;

        summernote.val(self.value);
        summernote.summernote(this.settings);

        summernote.on('summernote.init', () => {
            this.init.emit();
        });

        summernote.on('summernote.enter', () => {
            this.enter.emit();
        });

        summernote.on('summernote.focus', () => {
            this.focus.emit();
        });

        summernote.on('summernote.blur', () => {
            this.blur.emit();
        });

        summernote.on('summernote.keyup', () => {
            this.keyup.emit();
        });

        summernote.on('summernote.keydown', () => {
            this.keydown.emit();
        });

        summernote.on('summernote.paste', () => {
            this.paste.emit();
        });

        summernote.on('summernote.upload', () => {
            this.upload.emit();
        });

        self.zone.run(() => {

            summernote.on('summernote.change', () => {
                self.value = summernote.val();
                console.log(self.value);

                this.change.emit();
            });

        });


    }

    // Setting get and set.

    protected setSetting(key: string, value: any, def?: any) {

        if (value || !value && def) {
            this.settings[key] = value ? value : def;
        }

    }

    protected getSetting(key: string) {

        return this.settings[key];

    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/wysiwyg/wysiwyg.component.ts